// extracted by mini-css-extract-plugin
module.exports = {"logo":"HeaderWrapper_logo__2OduQ","desktop":"HeaderWrapper_desktop__mZe4G","mobile":"HeaderWrapper_mobile__1SqYs"};